import React from "react";
import { PlainButton } from "@culturehq/components";

import styles from "./dot-tab.module.scss";

type DotTabProps = {
  active: boolean;
  ariaLabel: string;
  onClick: () => void;
};

const DotTab: React.FC<DotTabProps> = ({ active, ariaLabel, onClick }) => (
  <PlainButton
    role="tab"
    aria-selected={active}
    aria-current={active}
    aria-label={ariaLabel}
    onClick={onClick}
    className={styles["dot-tab"]}
    title={ariaLabel}
  />
);

export default DotTab;
